import Clarity from '@microsoft/clarity';

export const initiateMsClariry = (projectId: string) => {
  Clarity.init(projectId);
};
